<template>
  <div class="selectAfterSalesType">
    <Header pageTitle="选择售后类型" />
    <div class="content">
      <div v-if="data.includes(1)" class="content-item refund" ref="barter" @touchstart="touchstart('barter')"
        @touchend="touchend('barter', 1)">
        <div class="left">
          <img src="@/assets/mylogin/replace.png" alt="">
        </div>
        <div class="right">
          <div>
            <div style="margin-bottom: 5px;">换货</div>
            <div class="text">对收到的商品不满意，申请换货</div>
          </div>
        </div>
      </div>
      <div v-if="data.includes(2)" class="content-item refund" ref="refund" @touchstart="touchstart('refund')"
        @touchend="touchend('refund', 2)">
        <div class="left">
          <img src="@/assets/mylogin/quit.png" alt="">
        </div>
        <div class="right">
          <div>
            <div style="margin-bottom: 5px;">退货退款</div>
            <div class="text">已收到货，需要退还已收到的货物</div>
          </div>
        </div>
      </div>
      <div v-if="data.includes(3)" class="content-item refund" ref="rebate" @touchstart="touchstart('rebate')"
        @touchend="touchend('rebate', 3)">
        <div class="left">
          <img src="@/assets/mylogin/tuikuanzhong@2x.png" alt="">
        </div>
        <div class="right">
          <div>
            <div style="margin-bottom: 5px;">仅退款</div>
            <div class="text">未收到货，或与商家协商后申请</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/views/mobileView/components/header/index.vue";
export default {
  components: {
    Header
  },
  data() {
    return {
      data: []
    }
  },
  created() {
    this.getAfterSalesType()
  },
  methods: {
    async getAfterSalesType() {
      let res = await this.$apis.afterSalesOrder.getAfterSalesType({
        orderGoodsId: this.$route.query.id
      })
      this.data = res.data
    },
    touchstart(key) {
      this.$refs[key].style.background = 'rgba(105,105,105,0.2)'
    },
    touchend(key, type) {
      this.$refs[key].style.background = '#fff'
      this.$router.push({
        name: "refundRebate",
        query: {
          afterType: type,
          ...this.$route.query
        },
      });
    }
  }
}
</script>
<style lang="scss">
html,
body {
  height: 100%;
  background: #f5f5f5;
}

.selectAfterSalesType {
  padding-top: calc(constant(safe-area-inset-top) + 44px) !important;
  padding-top: calc(env(safe-area-inset-top) + 44px) !important;

  .content {
    padding: 0 12px 0;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .content-item {
      width: calc(100% - 1px);
      background: white;
      border: 1px solid white;
      border-radius: 13px;
      padding: 0 16px;
      height: 78.5px;
      background: white;
    }

    .refund {
      margin-top: 12px;
      display: flex;
      justify-content: space-between;

      .left {
        display: flex;
        align-items: center;

        img {
          width: 23px;
          height: 23px;
        }
      }

      .right {
        display: flex;
        align-items: center;
        width: calc(90% - 16px);
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;

        .text {
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
        }
      }
    }
  }
}</style>